<template>
  <el-dialog
    show-close
    :visible.sync="visible"
    width="800px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <div>
      <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_platformCode') || '平台'"
              prop="platformCode"
            >
              <dict-select
                v-model="formData.platformCode"
                :selectedLabel.sync="formData.platformName"
                url="/ecomorder/ecom/platform/select"
                :placeholder="
                  $l('table_label_please_select_platformCode') || '请选择平台'
                "
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_platformAccountCode') || '账号'"
              prop="platformAccountCode"
            >
              <dict-select
                v-model="formData.platformAccountCode"
                :selectedLabel.sync="formData.accountName"
                :body="{ platformCode: formData.platformCode || 'xxxx' }"
                url="/ecom/evg/platform/select/account"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_expandParam') || '附加参数'"
              prop="expandParam"
            >
              <el-input
                v-model="formData.expandParam"
                :placeholder="$l('tips_input_expandParam') || '请输入附加参数'"
                type="textarea"
                :rows="5"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_condition') || '使用条件'"
              prop="condition"
            >
              <el-input
                v-model="formData.condition"
                :placeholder="$l('tips_input_condition') || '请输入使用条件'"
                type="textarea"
                :rows="5"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_isDefault') || '是否默认'"
              prop="isDefault"
            >
              <div style="display: flex;width: 100%;">
                <label
                  :class="{
                    'is-checked': formData.isDefault == 'Y',
                  }"
                  class="el-checkbox"
                  @click.stop="changeDefault"
                  style="display: flex;"
                  ><span
                    class="el-checkbox__input "
                    :class="{
                      'is-checked': formData.isDefault == 'Y',
                    }"
                    ><span class="el-checkbox__inner"></span></span
                ></label>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="confirm()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'

export default {
  props: {
    logisticsAccount: { type: Object, default: () => {} },
    type: { type: String, default: '' },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('dialog_title_logistics_edit') || '编辑物流平台',
        add: this.$l('dialog_title_logistics_add') || '新增物流平台',
        detail: this.$l('dialog_title_logistics_detail') || '物流平台详情',
      },
      formData: {
        isDefault: 'N',
      },
      rules: {
        platformCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        platformAccountCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  watch: {
    logisticsAccount: {
      handler() {
        this.formData = JSON.parse(
          JSON.stringify(this.logisticsAccount || { isDefault: 'N' })
        )
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'detail'
    },
  },
  methods: {
    close() {
      this.formData = { isDefault: 'N' }
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.$emit('confirm', this.type, this.formData)
      close()
    },
    changeDefault() {
      if (this.disabled) {
        return
      }
      if (this.formData.isDefault === 'Y') {
        this.formData.isDefault = 'N'
      } else {
        this.formData.isDefault = 'Y'
      }
    },
  },
}
</script>
